import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { downgradeComponent } from '@angular/upgrade/static';
// Third-party modules

// Shared modules
import { CoreModule } from '../core';
import { SharedModule } from '../shared';

// UI Components
// Module's pages components.
import { ProfileSeasonalWorldComponent } from './profile-seasonal-world.component';

import { SeasonsUsersRanksService } from './seasons-users-ranks.service';

@NgModule({
    imports: [
        CommonModule,
        // Third-party modules
        // Shared modules
        CoreModule,
        SharedModule,
        // Current module imports
    ],
    declarations: [
        ProfileSeasonalWorldComponent
    ],
    exports: [
    ],
    providers: [
        SeasonsUsersRanksService
    ],
    entryComponents: [
        ProfileSeasonalWorldComponent
    ]
})
export class ProfileModule { }

declare const angular: angular.IAngularStatic;

angular.module('app')
    .directive('app2ProfileSeasonalWorld', downgradeComponent({
        component: ProfileSeasonalWorldComponent,
        inputs: ['user']
    }));
